'use client';

import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCartItemsAsync } from '@/redux/thunk/carts-thunk';
import Button from '../Button';
import Icon from '../Icon';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

export default function CartMenu() {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false);
  const { items: cart } = useSelector((state) => state.carts);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return (
    <div className="cart-menu hidden lg:block relative z-[511]">
      <div className="group relative inline-block">
        <Button
          type="link"
          className="min-w-[32px] 3xl:min-w-[32px] min-h-[32px] 3xl:min-h-[32px] border border-richcarmine rounded-[100px] bg-white hidden lg:flex justify-center items-center relative !p-0"
          onClick={() => {
            dispatch(fetchCartItemsAsync());
            router.push('/cart');
          }}
        >
          <Icon type="cart" className="size-[24px] 3xl:size-[28px]" />
          {cart?.length > 0 ? (
            <Text
              type="span"
              className="bg-richcarmine w-[18px] h-[18px] flex justify-center items-center text-sm text-white !font-semibold leading-20 tracking-[0.28px] rounded-full absolute -top-[11px] -right-[7px]"
            >
              {cart.length}
            </Text>
          ) : null}
        </Button>

        <div className="hidden opacity-50 invisible transform absolute top-full left-0 w-[140px] max-h-[176px] overflow-y-auto z-[511] rounded-8 bg-white text-gunmetal pt-5 shadow-language-toggle transition-all duration-200 ease-out focus:outline-none thin-scrollbar">
          {cart.length > 0 ? (
            cart?.map((item, index) => (
              <div key={item.id}>
                <Button className="group flex w-full items-center gap-2 rounded-lg py-10 px-16">
                  <ImageComponentV2
                    src={item?.image?.[0]}
                    width={20}
                    height={20}
                    alt={`img-${index + 1}`}
                    loading="lazy"
                  />
                  <Text
                    type="paragraph"
                    className="!text-16 text-senate !font-medium font-encode-sans leading-24 tracking-[0.32px] flex items-center gap-[4px] line-clamp-1"
                  >
                    {item?.productName}
                  </Text>
                </Button>
              </div>
            ))
          ) : (
            <Text
              type="paragraph"
              className="!text-16 text-senate !font-medium font-encode-sans leading-24 tracking-[0.32px] p-10"
            >
              Empty cart!
            </Text>
          )}
        </div>
      </div>
    </div>
  );
}
